<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: "",
    },
  },
  emits: ["update:show"],
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
};
</script>

<template>
  <b-modal
    v-model="visible"
    title="Preview Gambar Jawaban"
    centered
    hide-footer
    size="lg"
  >
    <div class="text-center">
      <img
        :src="imageUrl"
        style="max-width: 100%; border-radius: 6px;"
      />
    </div>
  </b-modal>
</template>
